 document.addEventListener('DOMContentLoaded', ()=>{

  function disableScroll(){
    window.scrollTo(0,0);
  }


  const subMenu = document.querySelector('.sub-menu');
  const hover = document.querySelector('.hover');
  const iconBurguer = document.querySelector('.icon-burguer');
  const menuMobile= document.querySelector('.menu-mobile');
  const menuMobileItems = document.querySelector('.menu-mobile-items')
  const btnBack= document.querySelector('.btn-li');
  const subMenuMobile = document.querySelector('.space-items');
  const iconClose = document.querySelector('.icono-close');
  const iconContainer =document.querySelector('.icon-close-container');
  const containerMobile= document.querySelector('.container-mobile-menu')

  iconClose.addEventListener('click',function(){
    window.removeEventListener('scroll',disableScroll);

  menuMobileItems.classList.remove('active');

  menuMobile.style.transform='translateX(-100%)';
  containerMobile.style.opacity='0';
  iconClose.style.transitionDelay='.2s';
  iconClose.style.opacity='0';
  containerMobile.style.zIndex='0';
  containerMobile.style.display='none';
})


iconBurguer.addEventListener('click',function(){
  window.addEventListener('scroll',disableScroll)

 menuMobileItems.classList.toggle('active');

  if (menuMobileItems.classList.contains('active')) {
    containerMobile.style.display='flex';
    containerMobile.style.left='0'
    menuMobile.style.transform='translateX(0)'
    containerMobile.style.transitionDelay='.2s';
    containerMobile.style.opacity='1'
    containerMobile.style.zIndex='100'
    iconClose.style.transitionDelay='.4s';
    iconClose.style.opacity='1';
    iconClose.style.zIndex='100'
  }else {
    return false
  }
})

subMenuMobile.addEventListener('click',()=>{
  menuMobileItems.style.transform='translateX(-100%)'
  menuMobileItems.style.transition='350ms cubic-bezier(.55,0,.1,1)'
})

btnBack.addEventListener('click',()=>{
  menuMobileItems.style.transform='translateX(0)'
})

  })

window.addEventListener('DOMContentLoaded', () => {
  var element = document.getElementsByClassName('container-icon-bag');
  var cart = document.getElementsByClassName('hidden-cart');
  var container = document.getElementsByClassName('cart');
  var container_cart = document.getElementsByClassName('container-cart');
  var html = document.querySelector("html");
  element[0].addEventListener("click", function(){
      cart[0].classList.add('active')
      setTimeout(function(){ 
        container[0].classList.add('active')
        container_cart[0].classList.add('active')
       }, 200);
      document.body.style.cssText = 'overflow: hidden;';
      html.style.cssText = 'overflow: hidden;';
  });

  
  var close = document.getElementsByClassName('close-car');

  close[0].addEventListener("click", function(){
    container[0].classList.remove('active')
    container_cart[0].classList.remove('active')
    setTimeout(function(){ 
      cart[0].classList.remove('active')
     }, 500);
    document.body.style.cssText = 'overflow: auto;';
    html.style.cssText = 'overflow: auto;';
  });

})
